var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"powerbi-report-page"},[_c('iframe',{attrs:{"width":"100%","height":"600","src":_vm.powerbiurl,"frameborder":"0","allowFullScreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }